<template lang="html">
    <div class="resize-wrapper">
        <slot
            v-if="renderChildren"
            :height="height"
            :width="width"
        />
    </div>
</template>

<script>
import debounce from 'lodash.debounce';
import ResizeObserver from 'resize-observer-polyfill';
import throttle from 'lodash.throttle';

export default {
    name: 'RezizeWrapper',

    props: {
        throttle: {
            default: false,
            type: Boolean,
        },

        debounce: {
            default: false,
            type: Boolean,
        },

        interval: {
            default: 250,
            type: Number,
        },
    },

    data: () => ({
        height: 200,
        width: 200,
        renderChildren: false,
        resizeObserver: null,
    }),

    beforeDestroy() {
        // disconnect resizeObserver
        // (happens automatically when the observed element is destroyed,
        // but this way prevents the callback from firing extra times before
        // that finally happens)
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
    },

    mounted() {
        /**
         * use calculated dimensions to provide to child components
         * via the slot props
         */
        let callback = () => {
            this.height = this.h();
            this.width = this.w();
        };

        // run the callback once, to set the initial size
        callback();

        // render child components now that the initial dimensions are set
        this.renderChildren = true;

        // optionally throttle or debounce the resize callback function
        if (this.throttle) {
            callback = throttle(callback, this.interval);
        } else if (this.debounce) {
            callback = debounce(callback, this.interval);
        }

        this.resizeObserver = new ResizeObserver(callback);
        this.resizeObserver.observe(this.$el);
    },

    methods: {
        /**
         * returns the calculated height of the component root element
         * @return {Number} calculated height of $el
         */
        h() {
            return Math.floor(this.$el.offsetHeight);
        },

        /**
         * returns the calculated width of the component root element
         * @return {Number} calculated height of $el
         */
        w() {
            return Math.floor(this.$el.offsetWidth);
        },
    },
};
</script>

<style lang="css">
.resize-wrapper {
    width: 100%;
    height: 100%;
}
</style>
